import { provideEffects } from '@ngrx/effects';

import { NgrxReportsEffect } from './effects/ngrx-reports.effect';

export function provideNgrxReports() {
    return [provideEffects([NgrxReportsEffect])];
}
